(function () {
    'use strict';

    angular.module("imApp").factory("custactPlansService", ['$ihttp', function ($ihttp) {
        let service = {
            getSetting: function (parms) {
                return $ihttp.post({
                    method: 797,
                    parameters: parms || {}
                });
            },
            loadCustPlansList: function (setting) {
                return $ihttp.post({
                    method: 798,
                    parameters: setting
                });
            }
        };

        return service;
    }]);
})();
